import React, {Fragment} from 'react';
import {Props} from '../Builder/ElementProperties';

const AudioElement = (props) => {
	const url = Props.getMediaURL({props});
	return (
		<audio 
			width={props.element.width} 
			height={props.element.height} 
			controls={props.element.showControls}
			autoPlay={!props.builder && props.element.autoPlay}
			onPlay={e =>{
				props.experiment.recordEvent({eventType:'Media Event', actionType:'audio.play', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'audio', value: 'play' });
				props.experiment.forceUpdate();
			}}
			onPause={e =>{
				props.experiment.recordEvent({eventType:'Media Event', actionType:'audio.pause', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'audio', value: 'pause' });
				props.experiment.forceUpdate();
			}}
			onEnded={e =>{
				props.experiment.recordEvent({eventType:'Media Event', actionType:'audio.end', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'audio', value: 'end' });
				Props.onClickHandler({props, field:'onEnd'});
			}}
		>
			<source src={url} type="audio/ogg" />
			Your browser does not support the audio tag.
		</audio>
	);
}

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.URL {...props} />
		<Props.ShowControls {...props} />
		<Props.AutoPlay {...props} />
		<Props.OnEnd {...props} />
	</Fragment>
);

AudioElement.type = 'audio';
AudioElement.Properties = Properties;
AudioElement.defaultJSON = {type: 'audio', id:'New Audio', x: 250, y:250, width:320, height:50, 
url:'https://upload.wikimedia.org/wikipedia/commons/3/3c/01_-_Vivaldi_Spring_mvt_1_Allegro_-_John_Harrison_violin.ogg', onEnd:'', showControls:'true', autoPlay:''
};
export default AudioElement;


// WEBPACK FOOTER //
// ./src/components/ScreenElements/AudioElement.js